// extracted by mini-css-extract-plugin
export var compact = "TSNPD";
export var full = "WIYG1";
export var listViewBadge = "PGUv1";
export var medium = "Idtcl";
export var plainBadge = "Mt2TB";
export var unreadCount = "e0wpX";
export var unreadOrTotalCount = "BptzE";